import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetch("/data/testimonials.json")
      .then((res) => res.json())
      .then((data) => setTestimonials(data))
      .catch((err) => console.error("Failed to load testimonials:", err));
  }, []);

  if (!testimonials.length) return null;

  return (
    <section className="w-full mt-16 px-6">
      <h2 className="heading-sub text-center mb-8">Testimonials</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {testimonials.map((t, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
            className={`
              h-full flex flex-col justify-end
              shadow-md hover:shadow-xl hover:-translate-y-1
              transition-all duration-300 rounded-xl p-6 border transform hover:scale-105
            
              ${t.featured 
                ? "md:col-span-2 bg-blue-50/60 border-blue-300 ring-2 ring-blue-200/40 shadow-blue-500/10" 
                : "bg-white border-gray-200"
              }
            `}
          >
            <div className="text-5xl leading-none text-gray-600 mb-2">“</div>

              <div className="space-y-3 flex-1">
              {t.messageAr && (
                <p className="text-gray-700 italic leading-8 text-right" dir="rtl">
                  "{t.messageAr}"
                </p>
              )}

              <p className="text-gray-800 italic leading-relaxed">
                "{t.message}"
              </p>
             </div>

             <div className="mt-auto pt-4">
              <div className="text-sm font-semibold text-gray-900">
                {t.name}
              </div>

              <div className="text-xs text-gray-700">
                {t.role} {t.company ? `• ${t.company}` : ""}
              </div>

              {t.date && (
                <div className="text-xs text-gray-500 mt-1">
                  {t.date}
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;